const initials = window.__initials__;

const settings = initials.app_configs;
const base_url = initials.app_url;
const active_user = initials.user;
const active_roles = active_user ? active_user.role : "";

export { settings, base_url, active_roles, active_user };
